import script from "./admin-index.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-index.vue?vue&type=script&setup=true&lang=js"

import "./admin-index.vue?vue&type=style&index=0&id=dc35e0aa&lang=scss"

const __exports__ = script;

export default __exports__